import React, { useState } from 'react';

export default function NotificationBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="notification-banner notification-banner--warning">
      <div className="notification-banner__container">
        <div className="notification-banner__header">
          <h2 className="notification-banner__title">⚠️ Important Notice</h2>
          <button 
            className="notification-banner__close" 
            aria-label="Close notification"
            onClick={() => setIsVisible(false)}
          >
            ×
          </button>
        </div>

        <p className="notification-banner__text">
          We experienced a technical incident on July 31, 2026 that resulted in the loss of registration data and photo uploads. We sincerely apologize for any inconvenience this may cause.
        </p>

        <div className="notification-banner__content">
          <h3>What Was Affected</h3>
          <ul>
            <li>All registration entries and user accounts have been reset</li>
            <li>All uploaded photos and media files have been permanently lost</li>
            <li>Login credentials are no longer valid</li>
          </ul>

          <h3>What You Need to Do</h3>

          <div className="notification-banner__section">
            <strong>If you are a Performer, Group, Costume Designer, or Artist:</strong>
            <ul>
              <li>Please log in (or create a new account) and update your registration</li>
              <li>Re-upload all photos and documentation</li>
              <li>Verify that all information is complete and accurate</li>
            </ul>
          </div>

          <div className="notification-banner__section">
            <strong>If you submitted an entry or registration:</strong>
            <ul>
              <li>Please submit a new entry with all required information</li>
              <li>Re-upload any photos or supporting documents</li>
              <li>If you have questions about your original submission, please contact us</li>
            </ul>
          </div>

          <h3>Recovery Status</h3>
          <ul>
            <li>All backup systems have been reviewed</li>
            <li>The application is now fully operational</li>
            <li>New registrations and uploads can be submitted immediately</li>
          </ul>

          <p className="notification-banner__footer">
            Thank you for your patience and understanding.
          </p>
        </div>
      </div>
    </div>
  );
}
